import React, { useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSelector, useDispatch } from 'react-redux';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import FilterSuggestionList from './Filter/FilterSuggestionList';
import * as todoAction from './store/Suggestion.action';
import List from './List';
import { Page_Size } from '../../../../Components/helper';

function Suggestions() {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const reducers = useSelector((redState) => redState);
  const {
    SuggestionTodoListData: {
      suggestionListData,
      suggestionListTotalCount,
      suggestionFilterValues: {
        selectedSuggestion_Season,
        selectedSuggestion_Year,
        selectedSuggestion_Brand,
        selectedSuggestion_Supplier,
        selectedSuggestion_Category1,
        selectedSuggestion_Category2,
        selectedSuggestion_Category3,
        selectedSuggestion_Category4,
        selectedSuggestion_Status,
        selectedSuggestion_Section,
        selectedSuggestion_ActionType,

        pageIndex,
        pageSize,
      },
      suggestionTodoListCount,
      suggestionSelectedIds,
    },
  } = reducers;

  const getCount = (selectedCnt) => {
    setState((prevState) => ({
      ...prevState,
      selectedCount: selectedCnt.length,
    }));
  };

  const [state, setState] = useState({
    suggestionTodoList: [],
    isLoading: false,
    hasMore: false,
    loading: true,
    totalRecords: null,
    searchLoaded: false,
    isExportLoading: false,
    isDownloadLoading: false,
    selectedCount: 0,
  });

  useEffect(() => {
    const callFn = async () => {
      let filterd = {};
      const obj = JSON.parse(localStorage.getItem('suggestionTodoListFilter'));
      if (obj) {
        filterd = {
          seasons: obj.selectedSuggestion_Season,
          year: obj.selectedSuggestion_Year,
          brand: obj.selectedSuggestion_Brand,
          supplier: obj.selectedSuggestion_Supplier,
          status: obj.selectedSuggestion_Status,
          category1: obj.selectedSuggestion_Category1,
          category2: obj.selectedSuggestion_Category2,
          category3: obj.selectedSuggestion_Category3,
          category4: obj.selectedSuggestion_Category4,
          section: obj.selectedSuggestion_Section,
          actionType: obj.selectedSuggestion_ActionType,
          licensorId: obj.selectedLicensor,
          licenseId: obj.selectedLicense,
          likenessId: obj.selectedLikeness,
        };
        obj.pageIndex = 1;
        await dispatch(todoAction.filterSortData(obj));
      }

      const params = {
        pageSize,
        pageIndex: 1,
        type: 'suggestion',
        ...filterd,
      };
      setState((prevState) => ({ ...prevState, isLoading: true }));

      const res = await dispatch(todoAction.getSuggestionList(params));
      if (res) {
        setState((prevState) => ({
          ...prevState,
          suggestionTodoList: res,
          hasMore: true,
          isLoading: false,
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          isLoading: false,
        }));
      }
    };
    callFn();
  }, [dispatch]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (state.searchLoaded) {
        const params = {
          pageIndex: 1,
          pageSize: Page_Size,
          seasons: selectedSuggestion_Season,
          year: selectedSuggestion_Year,
          brand: selectedSuggestion_Brand,
          supplier: selectedSuggestion_Supplier,
          actionType: selectedSuggestion_ActionType,
          status: selectedSuggestion_Status,
          category1: selectedSuggestion_Category1,
          category2: selectedSuggestion_Category2,
          category3: selectedSuggestion_Category3,
          category4: selectedSuggestion_Category4,
          type: 'suggestion',
        };
        await dispatch(todoAction.getSuggestionList(params));
        setState((searchEndState) => ({
          ...searchEndState,
          isLoading: false,
          searchLoaded: false,
        }));
      }
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    if (suggestionListTotalCount > suggestionListData.length) {
      setState((inInfinitestate) => ({
        ...inInfinitestate,

        hasMore: true,
      }));
    } else
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: false,
      }));
  }, [suggestionListData.length, suggestionListTotalCount]);

  const handlePageNextInScroll = async () => {
    let index = pageIndex;
    index += 1;
    const params = {
      seasons: selectedSuggestion_Season,
      year: selectedSuggestion_Year,
      brand: selectedSuggestion_Brand,
      supplier: selectedSuggestion_Supplier,
      actionType: selectedSuggestion_ActionType,
      status: selectedSuggestion_Status,
      section: selectedSuggestion_Section,
      category1: selectedSuggestion_Category1,
      category2: selectedSuggestion_Category2,
      category3: selectedSuggestion_Category3,
      category4: selectedSuggestion_Category4,
      pageIndex: index,
      pageSize,
      totalRecords: suggestionTodoListCount,
      isScrolled: true,
      type: 'suggestion',
    };

    const obj = {
      pageIndex: index,
      pageSize,
    };
    setState((prevState) => ({ ...prevState, isLoading: true }));
    await dispatch(todoAction.filterSortData(obj));
    await dispatch(todoAction.getSuggestionList(params));
    setState((prevState) => ({ ...prevState, isLoading: false }));
  };

  const exportFiles = async (type) => {
    const params = {
      pageIndex: 1,
      pageSize: Page_Size,
      seasons: selectedSuggestion_Season,
      year: selectedSuggestion_Year,
      brand: selectedSuggestion_Brand,
      supplier: selectedSuggestion_Supplier,
      actionType: selectedSuggestion_ActionType,
      status: selectedSuggestion_Status,
      category1: selectedSuggestion_Category1,
      category2: selectedSuggestion_Category2,
      category3: selectedSuggestion_Category3,
      category4: selectedSuggestion_Category4,
      type: 'suggestion',
      suggestionIds: suggestionSelectedIds,
      downloadType: type,
    };

    if (type === 'pdf') {
      setState((prevState) => ({ ...prevState, isDownloadLoading: true }));
      await dispatch(todoAction.exportToPdf(params));
      setState((prevState) => ({ ...prevState, isDownloadLoading: false }));
    } else {
      setState((prevState) => ({ ...prevState, isExportLoading: true }));
      await dispatch(todoAction.exportExcel(params));
      setState((prevState) => ({ ...prevState, isExportLoading: false }));
    }
  };

  return (
    <>
      <div>
        <div className="page-title-filter sticky">
          <div className="title-container d-flex align-items-center">
            <h4 className="title">{t('REPORTS.SUPPLIER_SUGGESTION_TO_DO')}</h4>
          </div>
          <div className="search-filter">
            {state.selectedCount > 0 && (
              <span className="txt-selected-cnt">
                {state.selectedCount} {t('COSTING_TO_DO_LIST.RECORD_SELECTED')}
              </span>
            )}
            {suggestionListTotalCount > 0 && (
              <span className="d-none d-md-inline-block txt-selected-cnt">
                {suggestionListTotalCount} {t('COSTING_TO_DO_LIST.TOTAL_RECORDS')}
              </span>
            )}
            <FilterSuggestionList />
            <Dropdown className="supplier-more-option d-flex">
              <Dropdown.Toggle disabled={suggestionListTotalCount < 1}>
                <button className="filter-btn filter-button_delete" type="button" title={t('COSTING_TO_DO_LIST.EXPORT_EXCEL')}>
                  <i title={t('PROGRESS_INDICATOR.DOWNLOAD_EXCEL')} className="icon-download" />
                </button>
              </Dropdown.Toggle>
              <Dropdown.Menu align="end">
                <a className={state.isDownloadLoading ? 'dropdown-item disabled-btn' : 'dropdown-item'} href={() => false} onClick={() => exportFiles('pdf')}>
                  {state.isDownloadLoading ? t('PROGRESS_INDICATOR.DOWNLOADING') : t('PROGRESS_INDICATOR.DOWNLOAD_PDF')}
                </a>
                <a className={state.isExportLoading ? 'dropdown-item disabled-btn' : 'dropdown-item'} href={() => false} onClick={() => exportFiles('excel')}>
                  {state.isExportLoading ? t('PROGRESS_INDICATOR.EXPORTING') : t('PROGRESS_INDICATOR.EXPORT_EXCEL')}
                </a>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
      <div className="scroll-container">
        <span className="top" />
        <span className="left" />
        <span className="right" />
        <div className="all-scroll">
          <div
            id="scrollableDiv"
            style={{
              height: '100%',
              overflow: 'scroll',
            }}
          >
            <InfiniteScroll
              dataLength={state.suggestionTodoList.length} // This is important field to render the next data
              hasMore={state.hasMore}
              next={() => handlePageNextInScroll()}
              scrollableTarget="scrollableDiv"
              className="fixed-col-container"
            >
              <List loading={state.isLoading} getSelectedCount={getCount} />
            </InfiniteScroll>
          </div>
        </div>
      </div>
    </>
  );
}

export default Suggestions;
